import { deselectCalendarDay } from 'actions/calendar_day'
import { eventBaseErrorsSelector } from 'selectors'
import { eventTypePathSelector } from 'selectors/url'

export const setGeneralError = (error) => ({
  type: 'SET_GENERAL_ERROR',
  payload: error
})

export const dismissGeneralError = (error) => ({
  type: 'DISMISS_GENERAL_ERROR',
  payload: error
})

export const dismissScheduleError = () => ({
  type: 'DISMISS_SCHEDULE_ERROR'
})

export const handleScheduleError = () => (dispatch, getState, { history }) => {
  const state = getState()
  const {
    key
  } = eventBaseErrorsSelector(state)

  switch (key) {
    case 'spot_already_filled':
      dispatch({ type: 'CLEAR_CALENDAR_DATA' })
      dispatch(deselectCalendarDay())
      history.push(eventTypePathSelector(getState(), true))
      break
    default:
      dispatch(dismissScheduleError())
  }
}

export const setScheduleError = (data) => ({
  type: 'SCHEDULING_FAIL',
  payload: data
})

export const dismissValidationError = (model, attribute) => ({
  type: 'DISMISS_SCHEDULE_VALIDATION_ERROR',
  payload: {
    model,
    attribute
  }
})
